









































































import {
  defineComponent, defineAsyncComponent, ref, onBeforeUnmount,
  computed, onMounted,
} from '@vue/composition-api';

import {
  RightPackageTypeEnum, SuperMemberSourceEnum, PayWayEnum, PackageBuyStatusEnum,
} from '@/api/rights/types';
import type { RightContractPopType } from '@/components/right-contract-pop/right-pop';
import { openThirdPage } from '@/api/native/utils';
import { RightsPayInstance } from '@/shared/right-utils/rightsPay';
import {
  RIGHTS_ENTER, RIGHTS_AGREEMENT, RIGHTS_AGREEMENT_CHECK, RIGHTS_DETAIL_DETAIL_OPEN,
} from '@/shared/right-utils/ubtRights';
import { ubtSetupPageButton, ubtSetupModuleExpose, getSetupBusinessInfo } from '@/shared/utils/ubt/ubt-setup';
import { RightHelper } from '@/shared/right-router-helper';
import { goBindBankCard } from '@/shared/right-utils/cardbind';
import { ForceReadService } from '@/widgets/right-contract';
import { ubtSendError } from '@/shared/utils/ubt';
import { ContractReadStatusEnum } from '@/widgets/right-contract/enum';

/** 提现单里的成功遮罩层 */
const SuccessOverlayApply = () => import(
  /* webpackChunkName: "async-success-overlay-apply" */ '@/widgets/rights/SuccessOverlay.vue'
);

/** 协议组件 */
const ContactPopApply = () => import(
  /* webpackChunkName: "async-right-contact-pop-apply" */ '@/components/right-contract-pop'
);

const SuccessOverlay = defineAsyncComponent(SuccessOverlayApply);
const ContactPop = defineAsyncComponent(ContactPopApply);

export default defineComponent({
  props: {
    superMemberCardSummary: Object,
  },
  components: {
    ContactPop,
    SuccessOverlay,
  },
  setup(props, { emit }) {
    /** 是否勾选 */
    const isChecked = ref<boolean>(false);

    /** 协议弹窗ref */
    const rightContractPop = ref<RightContractPopType>();

    /** 是否展示提示气泡 */
    const showBuyConfirm = ref<boolean>(false);

    /** 订单id */
    const orderId = ref<string>('');

    const tqParams = computed(() => {
      const {
        packageId, packageType, supplierCode, sellPrice, packageName,
      } = props.superMemberCardSummary || {};
      return {
        packageId,
        packageType,
        supplierCode,
        packageName,
        sellPrice,
        from: SuperMemberSourceEnum.APPLY_NO_RECORD,
      };
    });

    const {
      readStatus, handleForceRead, destroyInstance,
    } = ForceReadService({
      packageType: RightPackageTypeEnum.SUPER_MEMBER_CARD,
      forceReadFromScene: SuperMemberSourceEnum.APPLY_NO_RECORD,
    });

    /** 变更勾选状态 */
    const changeChecked = async () => {
      isChecked.value = !isChecked.value;
      /** 勾选状态为选中时上报 */
      if (isChecked.value) {
        ubtSetupPageButton(RIGHTS_AGREEMENT_CHECK, {
          ...tqParams.value,
          checkStatus: isChecked.value,
        });

        const { contractInfo } = props.superMemberCardSummary || {};
        isChecked.value = await handleForceRead({
          contractScene: contractInfo?.scene || '',
          tqParams: tqParams.value,
        });
      }
    };

    /** 是否展示成功浮层 */
    const showSuccOverlay = ref<boolean>(false);

    /** 打开协议弹窗 */
    const openContract = async () => {
      /** 点击协议弹窗曝光 */
      ubtSetupPageButton(RIGHTS_AGREEMENT, tqParams.value);
      if (props.superMemberCardSummary
      && props.superMemberCardSummary.contractInfo) {
        const { contractInfo } = props.superMemberCardSummary;
        const handleRes = await handleForceRead({
          contractScene: contractInfo?.scene || '',
          tqParams: tqParams.value,
          preview: true,
        });
        // 只有勾选时再改变勾选状态
        if (handleRes) {
          isChecked.value = handleRes;
        }
      }
    };

    /** 去支付 */
    const goPay = async () => {
      // 这里只处理打点，不做任何接口层面的二次校验
      if (readStatus === ContractReadStatusEnum.NEED_READ_NOT_READ) {
        ubtSendError({
          name: 'right_force_read',
          message: 'needReadContract but not read',
          stack: SuperMemberSourceEnum.APPLY_NO_RECORD,
        });
      }

      if (props.superMemberCardSummary) {
        const {
          packageType, packageId, sellPrice, payWay, isSelectPayWay, contractInfo,
        } = props.superMemberCardSummary;

        if (!isSelectPayWay) {
          ubtSetupPageButton(RIGHTS_DETAIL_DETAIL_OPEN, tqParams.value);
        }

        if (!isSelectPayWay && !isChecked.value) {
          showBuyConfirm.value = true;
        } else {
          const payRes = await RightsPayInstance.H5pay({
            packageType: RightPackageTypeEnum.SUPER_MEMBER_CARD,
            packageId,
            needChoosePayWay: isSelectPayWay,
            contractInfo,
            payAmount: sellPrice,
            payWay,
            from: SuperMemberSourceEnum.MY_COUPON,
            businessInfo: getSetupBusinessInfo(tqParams.value),
            goBindBankCard: ((options: { scene: string; bindCardApplySessionId: string; }) => {
              const {
                scene, bindCardApplySessionId,
              } = options;
              goBindBankCard(
                SuperMemberSourceEnum.MY_COUPON,
                scene,
                packageId,
                bindCardApplySessionId,
                RightPackageTypeEnum.SUPER_MEMBER_CARD,
              );
            }),
          });
          /** 成功回调 */
          if (payRes && payRes.status === 1) {
            orderId.value = payRes.orderId;
            showSuccOverlay.value = true;
          }
        }
      }
    };

    /** 去往会员详情页 */
    const goDetail = () => {
      const url = RightHelper.dispatchRouterByBuyStatus(
        RightPackageTypeEnum.SUPER_MEMBER_CARD,
        SuperMemberSourceEnum.APPLY_NO_RECORD,
        PackageBuyStatusEnum.NOT_BUY,
      );

      openThirdPage(url);

      /** 监听回退事件 */
      document.addEventListener('visibilitychange', () => {
        /** 刷新数据 emit */
        if (document.visibilityState === 'visible') {
          emit('refreshSuperMember');
        }
      });
    };

    /** 更新遮罩层值 */
    const updateIsSuccOverlay = (value:boolean) => {
      showSuccOverlay.value = value;
    };

    /** 关闭开通成功蒙层回调 */
    const closeOverlay = () => {
      showSuccOverlay.value = false;
      emit('refreshSuperMember');
    };

    const payWayText = computed(() => {
      if (props.superMemberCardSummary && props.superMemberCardSummary.payWay === PayWayEnum.Card) {
        return '银行卡';
      }
      return '支付宝';
    });

    onMounted(() => {
      /** 曝光埋点 */
      ubtSetupModuleExpose(RIGHTS_ENTER, tqParams.value);
    });

    onBeforeUnmount(() => {
      document.removeEventListener('visibilitychange', () => {
        emit('refreshSuperMember');
      });
      destroyInstance();
    });

    return {
      isChecked,
      showBuyConfirm,
      rightContractPop,
      RightPackageTypeEnum,
      showSuccOverlay,
      payWayText,
      orderId,

      changeChecked,
      openContract,
      goPay,
      goDetail,
      closeOverlay,
      updateIsSuccOverlay,
    };
  },
});
